import * as React from 'react';

import * as Icons from '../../../icons';
import { Styled } from './styled';

export const VisibilityButton = (props) => {
  const { isHide, onClick } = props;
  const icon = isHide ? <Icons.Hide /> : <Icons.Show />;
  return <Styled.Icon onClick={onClick}>{icon}</Styled.Icon>;
};
